import childbirthKvImage380 from '~/components/templates/ProductLpTemplate/childbirth/kv_childbirth.png?w=380&convert';
import childbirthKvImage560 from '~/components/templates/ProductLpTemplate/childbirth/kv_childbirth.png?w=560&convert';
import childbirthKvImage600 from '~/components/templates/ProductLpTemplate/childbirth/kv_childbirth.png?w=600&convert';
import childbirthKvImage1200 from '~/components/templates/ProductLpTemplate/childbirth/kv_childbirth.png?w=1200&convert';
import educationFundKvImage380 from '~/components/templates/ProductLpTemplate/educationFund/kv_educationFund.png?w=380&convert';
import educationFundKvImage560 from '~/components/templates/ProductLpTemplate/educationFund/kv_educationFund.png?w=560&convert';
import educationFundKvImage600 from '~/components/templates/ProductLpTemplate/educationFund/kv_educationFund.png?w=600&convert';
import educationFundKvImage1200 from '~/components/templates/ProductLpTemplate/educationFund/kv_educationFund.png?w=1200&convert';
import financeDiagnosisKvImage380 from '~/components/templates/ProductLpTemplate/financeDiagnosis/kv_financeDiagnosis.png?w=380&convert';
import financeDiagnosisKvImage560 from '~/components/templates/ProductLpTemplate/financeDiagnosis/kv_financeDiagnosis.png?w=560&convert';
import financeDiagnosisKvImage600 from '~/components/templates/ProductLpTemplate/financeDiagnosis/kv_financeDiagnosis.png?w=600&convert';
import financeDiagnosisKvImage1200 from '~/components/templates/ProductLpTemplate/financeDiagnosis/kv_financeDiagnosis.png?w=1200&convert';
import idecoKvImage380 from '~/components/templates/ProductLpTemplate/ideco/kv_ideco.png?w=380&convert';
import idecoKvImage560 from '~/components/templates/ProductLpTemplate/ideco/kv_ideco.png?w=560&convert';
import idecoKvImage600 from '~/components/templates/ProductLpTemplate/ideco/kv_ideco.png?w=600&convert';
import idecoKvImage1200 from '~/components/templates/ProductLpTemplate/ideco/kv_ideco.png?w=1200&convert';
import insuranceKvImage380 from '~/components/templates/ProductLpTemplate/insurance/kv_insurance.png?w=380&convert';
import insuranceKvImage560 from '~/components/templates/ProductLpTemplate/insurance/kv_insurance.png?w=560&convert';
import insuranceKvImage600 from '~/components/templates/ProductLpTemplate/insurance/kv_insurance.png?w=600&convert';
import insuranceKvImage1200 from '~/components/templates/ProductLpTemplate/insurance/kv_insurance.png?w=1200&convert';
import investmenttrustKvImage380 from '~/components/templates/ProductLpTemplate/investmenttrust/kv_investmenttrust.png?w=380&convert';
import investmenttrustKvImage560 from '~/components/templates/ProductLpTemplate/investmenttrust/kv_investmenttrust.png?w=560&convert';
import investmenttrustKvImage600 from '~/components/templates/ProductLpTemplate/investmenttrust/kv_investmenttrust.png?w=600&convert';
import investmenttrustKvImage1200 from '~/components/templates/ProductLpTemplate/investmenttrust/kv_investmenttrust.png?w=1200&convert';
import lifeplanKvImage380 from '~/components/templates/ProductLpTemplate/lifeplan/kv_lifeplan.png?w=380&convert';
import lifeplanKvImage560 from '~/components/templates/ProductLpTemplate/lifeplan/kv_lifeplan.png?w=560&convert';
import lifeplanKvImage600 from '~/components/templates/ProductLpTemplate/lifeplan/kv_lifeplan.png?w=600&convert';
import lifeplanKvImage1200 from '~/components/templates/ProductLpTemplate/lifeplan/kv_lifeplan.png?w=1200&convert';
import marriageCostKvImage380 from '~/components/templates/ProductLpTemplate/marriageCost/kv_marriageCost.png?w=380&convert';
import marriageCostKvImage560 from '~/components/templates/ProductLpTemplate/marriageCost/kv_marriageCost.png?w=560&convert';
import marriageCostKvImage600 from '~/components/templates/ProductLpTemplate/marriageCost/kv_marriageCost.png?w=600&convert';
import marriageCostKvImage1200 from '~/components/templates/ProductLpTemplate/marriageCost/kv_marriageCost.png?w=1200&convert';
import mortgageKvImage380 from '~/components/templates/ProductLpTemplate/mortgage/kv_mortgage.png?w=380&convert';
import mortgageKvImage560 from '~/components/templates/ProductLpTemplate/mortgage/kv_mortgage.png?w=560&convert';
import mortgageKvImage600 from '~/components/templates/ProductLpTemplate/mortgage/kv_mortgage.png?w=600&convert';
import mortgageKvImage1200 from '~/components/templates/ProductLpTemplate/mortgage/kv_mortgage.png?w=1200&convert';
import nisaKvImage380 from '~/components/templates/ProductLpTemplate/nisa/kv_nisa.png?w=380&convert';
import nisaKvImage560 from '~/components/templates/ProductLpTemplate/nisa/kv_nisa.png?w=560&convert';
import nisaKvImage600 from '~/components/templates/ProductLpTemplate/nisa/kv_nisa.png?w=600&convert';
import nisaKvImage1200 from '~/components/templates/ProductLpTemplate/nisa/kv_nisa.png?w=1200&convert';
import retirementKvImage380 from '~/components/templates/ProductLpTemplate/retirement/kv_retirement.png?w=380&convert';
import retirementKvImage560 from '~/components/templates/ProductLpTemplate/retirement/kv_retirement.png?w=560&convert';
import retirementKvImage600 from '~/components/templates/ProductLpTemplate/retirement/kv_retirement.png?w=600&convert';
import retirementKvImage1200 from '~/components/templates/ProductLpTemplate/retirement/kv_retirement.png?w=1200&convert';
import trainingKvImage380 from '~/components/templates/ProductLpTemplate/training/kv_training.png?w=380&convert';
import trainingKvImage560 from '~/components/templates/ProductLpTemplate/training/kv_training.png?w=560&convert';
import trainingKvImage600 from '~/components/templates/ProductLpTemplate/training/kv_training.png?w=600&convert';
import trainingKvImage1200 from '~/components/templates/ProductLpTemplate/training/kv_training.png?w=1200&convert';

export type KvImageSrcset = {
  380: string; // 1xでSPの横幅380pxの画像
  600: string; // 1xでPCの横幅600pxの画像
  560: string; // 2xでSPの横幅380pxの画像
  1200: string; // 2xでPCの横幅600pxの画像
};

export const getSrcsetString = (srcset: KvImageSrcset): string => {
  return (Object.keys(srcset) as unknown as (keyof KvImageSrcset)[])
    .map((size) => `${srcset[size]} ${size}w`)
    .join(', ');
};

export const getMaxSizeSrc = (srcset: KvImageSrcset): string => {
  return srcset[1200];
};

export const nisaKvImageSrcset: KvImageSrcset = {
  1200: nisaKvImage1200,
  600: nisaKvImage600,
  560: nisaKvImage560,
  380: nisaKvImage380,
};

export const idecoKvImageSrcset: KvImageSrcset = {
  1200: idecoKvImage1200,
  600: idecoKvImage600,
  560: idecoKvImage560,
  380: idecoKvImage380,
};

export const investmenttrustKvImageSrcset: KvImageSrcset = {
  1200: investmenttrustKvImage1200,
  600: investmenttrustKvImage600,
  560: investmenttrustKvImage560,
  380: investmenttrustKvImage380,
};

export const educationFundKvImageSrcset: KvImageSrcset = {
  1200: educationFundKvImage1200,
  600: educationFundKvImage600,
  560: educationFundKvImage560,
  380: educationFundKvImage380,
};

export const retirementKvImageSrcset: KvImageSrcset = {
  1200: retirementKvImage1200,
  600: retirementKvImage600,
  560: retirementKvImage560,
  380: retirementKvImage380,
};

export const marriageCostKvImageSrcset: KvImageSrcset = {
  1200: marriageCostKvImage1200,
  600: marriageCostKvImage600,
  560: marriageCostKvImage560,
  380: marriageCostKvImage380,
};

export const childbirthKvImageSrcset: KvImageSrcset = {
  1200: childbirthKvImage1200,
  600: childbirthKvImage600,
  560: childbirthKvImage560,
  380: childbirthKvImage380,
};

export const mortgageKvImageSrcset: KvImageSrcset = {
  1200: mortgageKvImage1200,
  600: mortgageKvImage600,
  560: mortgageKvImage560,
  380: mortgageKvImage380,
};

export const lifeplanKvImageSrcset: KvImageSrcset = {
  1200: lifeplanKvImage1200,
  600: lifeplanKvImage600,
  560: lifeplanKvImage560,
  380: lifeplanKvImage380,
};

export const financeDiagnosisKvImageSrcset: KvImageSrcset = {
  1200: financeDiagnosisKvImage1200,
  600: financeDiagnosisKvImage600,
  560: financeDiagnosisKvImage560,
  380: financeDiagnosisKvImage380,
};

export const trainingKvImageSrcset: KvImageSrcset = {
  1200: trainingKvImage1200,
  600: trainingKvImage600,
  560: trainingKvImage560,
  380: trainingKvImage380,
};

export const insuranceKvImageSrcset: KvImageSrcset = {
  1200: insuranceKvImage1200,
  600: insuranceKvImage600,
  560: insuranceKvImage560,
  380: insuranceKvImage380,
};
